export default {
      id: "clinics-usage",
      viewBox: "0 0 30 33",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#clinics",
      toString: function () {
        return this.url;
      }
    }